<template>
  <div class="category-add-section">
    <button
      data-me="setting-vehicle-inspection-category-btn-add"
      type="button"
      class="category-add-section__button"
      @click="$emit('add')"
    >
      <span class="category-add-section__icon">
        <i class="mc-icon icon-fill_plus"></i>
      </span>
      <span class="category-add-section__label">{{ addCategoryLabel }}</span>
    </button>
  </div>
</template>

<script>
export default {
  emits: ['add'],
  computed: {
    addCategoryLabel() {
      return this.$t('vehicleInspection.form.addCategory')
    },
  },
}
</script>

<style lang="scss" scoped>
.category-add-section {
  margin-top: 16px;

  &__button {
    width: 100%;
    border: 1px dashed #9ab7df;
    background: #eef5ff;
    border-radius: 8px;
    padding: 20px 16px;
    color: $primary;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    font-weight: $font-weight-bold;

    &:hover {
      background: #e2eeff;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    border-radius: $border-radius-pill;
    background: $white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
}
</style>
